import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { AuthContext } from "./context/AuthContext"; // Adjust this path based on your project
import TestPage from "./pages/TestPage";
import LoginPage from "./pages/login/Login";
import NewManager from "./pages/newManager/NewManager";
import ChatbotPage from "./pages/chatbot/ChatbotPage";
import { DialogProvider } from "./context/DialogContext";
import LoadingSpinner from "./components/loading/LoadingSpinner";
import CustomerServiceSimulator from "./pages/chatbot/customerService/CustomerServiceSimulator";

const AppRouter = () => {
  const { loadingAuth } = useContext(AuthContext);

  if (loadingAuth) {
    return <LoadingSpinner />;
  }

  return (
    <div
      style={{ minHeight: "100dvh", display: "flex", flexDirection: "column" }}
    >
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Private routes */}
        <Route
          path="/newManager"
          element={
            <PrivateRoute>
              <DialogProvider>
                <NewManager />
              </DialogProvider>
            </PrivateRoute>
          }
        />
        <Route
          path="/testPage"
          element={
            <PrivateRoute>
              <TestPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/chatbot"
          element={
            <PrivateRoute>
              <ChatbotPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/customer-service"
          element={
            <PrivateRoute>
              <CustomerServiceSimulator />
            </PrivateRoute>
          }
        />

        {/* Default redirect route */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </div>
  );
};

export default AppRouter;
